"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateProjectLanguageAndPlatform = exports.MobileFramework = exports.JavaFramework = exports.WebJsFramework = exports.AutomationLanguage = void 0;
const http_assert_1 = __importDefault(require("http-assert"));
const projectTypes_1 = require("./projectTypes");
var AutomationLanguage;
(function (AutomationLanguage) {
    AutomationLanguage["Javascript"] = "javascript";
    AutomationLanguage["Typescript"] = "typescript";
    AutomationLanguage["Java"] = "java";
})(AutomationLanguage || (exports.AutomationLanguage = AutomationLanguage = {}));
/** Platforms offered for JavaScript/TypeScript projects. */
var WebJsFramework;
(function (WebJsFramework) {
    WebJsFramework["Cypress"] = "Cypress";
    WebJsFramework["CypressComponent"] = "Cypress Component";
    WebJsFramework["WebDriverJs"] = "WebDriverJS";
    WebJsFramework["Playwright"] = "Playwright";
    WebJsFramework["PlaywrightTest"] = "Playwright Test";
    WebJsFramework["Puppeteer"] = "Puppeteer";
    WebJsFramework["WebdriverIo"] = "WebdriverIO";
    WebJsFramework["WebdriverIoTestrunner"] = "WebdriverIO Testrunner";
})(WebJsFramework || (exports.WebJsFramework = WebJsFramework = {}));
/** Platforms offered for Java projects. */
var JavaFramework;
(function (JavaFramework) {
    JavaFramework["SeleniumWebDriver"] = "Selenium WebDriver";
    JavaFramework["Playwright"] = "Playwright";
})(JavaFramework || (exports.JavaFramework = JavaFramework = {}));
/** Platforms offered for Mobile (SDK) projects. */
var MobileFramework;
(function (MobileFramework) {
    MobileFramework["Appium"] = "Appium";
    MobileFramework["Espresso"] = "Espresso";
    MobileFramework["Maestro"] = "Maestro";
    MobileFramework["UiAutomator"] = "UI Automator";
    MobileFramework["XcuiTest"] = "XCUITest";
})(MobileFramework || (exports.MobileFramework = MobileFramework = {}));
const WATCHER_LANGUAGES = Object.values(AutomationLanguage);
const WEB_JS_PLATFORMS = Object.values(WebJsFramework);
const JAVA_PLATFORMS = Object.values(JavaFramework);
const MOBILE_PLATFORMS = Object.values(MobileFramework);
/**
 * Watcher's platform is paired to the selected language: JS/TS expose the web
 * frameworks, Java exposes the Java frameworks.
 */
const WATCHER_PLATFORMS_BY_LANGUAGE = {
    [AutomationLanguage.Javascript]: WEB_JS_PLATFORMS,
    [AutomationLanguage.Typescript]: WEB_JS_PLATFORMS,
    [AutomationLanguage.Java]: JAVA_PLATFORMS
};
/**
 * Validates the `test_language` / `test_platform` pair against the per-project-type contract.
 *
 * @throws Error with status 400 when the values don't match the contract for the project type.
 * @example
 * validateProjectLanguageAndPlatform({ selected_project_type: ProjectType.Watcher, test_language: AutomationLanguage.Java, test_platform: JavaFramework.Playwright }); // ok
 * @example
 * validateProjectLanguageAndPlatform({ selected_project_type: ProjectType.MobileAnalyzer, test_language: null, test_platform: null }); // ok
 */
const validateProjectLanguageAndPlatform = ({ selected_project_type, test_language, test_platform }) => {
    switch (selected_project_type) {
        case projectTypes_1.ProjectType.Watcher: {
            const allowedPlatforms = test_language && WATCHER_LANGUAGES.includes(test_language)
                ? WATCHER_PLATFORMS_BY_LANGUAGE[test_language]
                : undefined;
            (0, http_assert_1.default)(allowedPlatforms, 400, `Test language must be one of: ${WATCHER_LANGUAGES.join(', ')}`);
            (0, http_assert_1.default)(test_platform && allowedPlatforms.includes(test_platform), 400, `Test platform must be one of: ${allowedPlatforms.join(', ')}`);
            break;
        }
        case projectTypes_1.ProjectType.Mobile: {
            (0, http_assert_1.default)(test_language === null, 400, 'Test language must be null');
            (0, http_assert_1.default)(test_platform && MOBILE_PLATFORMS.includes(test_platform), 400, `Test platform must be one of: ${MOBILE_PLATFORMS.join(', ')}`);
            break;
        }
        case projectTypes_1.ProjectType.Html:
        case projectTypes_1.ProjectType.MobileAnalyzer:
            (0, http_assert_1.default)(test_language === null && test_platform === null, 400, 'Test language and test platform must both be null');
            break;
        default:
            (0, http_assert_1.default)(false, 400, 'Project type is not supported');
    }
};
exports.validateProjectLanguageAndPlatform = validateProjectLanguageAndPlatform;
//# sourceMappingURL=validateProjectLanguageAndPlatform.js.map